// The license of a licensed solution on the solutions family's wire
// (02-DESIGN/17-plans/03-solution-licenses.md § install and upgrade with a
// license, § the record, the page and the end; decision 0070 § 9). Mirrors
// impire-sdk-go solution/license.go and the license fields of
// solution/wire.go and manifest.go. The rest of the family's wire is the
// console's own mirror until a consumer here needs it; the browser carries a
// license and never verifies one.
/** LICENSE_TYPE is the JWS type a solution's license names. */
export const LICENSE_TYPE = "impire-solution-license+jwt";
/** MAX_LICENSE_HINT is the most runes a manifest's license hint may hold. */
export const MAX_LICENSE_HINT = 200;
/** The refusals a licensed manifest's install and upgrade answer with. */
export const LicenseCode = {
    /** No license given for a licensed manifest. */
    required: "license-required",
    /** A license that fails a check; the message names which. */
    invalid: "license-invalid",
    /** A license past its expiry. */
    expired: "license-expired",
};
//# sourceMappingURL=solution.js.map